import getPublishedStateHeader from '../../helpers/getPublishedStateHeader';

export const REQUEST = 'SITE_DOWNLOADABLE_AGENDA_REQUEST';
export const SUCCESS = 'SITE_DOWNLOADABLE_AGENDA_SUCCESS';
export const FAILURE = 'SITE_ DOWNLOADABLE_AGENDA_FAILURE';

const initialState = {
  loaded: false,
};

export default function siteDownloadableAgendaReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUCCESS:
      return Object.assign(
        {},
        {
          loaded: true,
          statusCode: action.data.statusCode,
          ...action.data.json,
        },
      );

    case FAILURE:
      return Object.assign({}, state, {
        error: true,
        statusCode: action.data.statusCode,
        ...action.data.json,
      });

    default:
      return state;
  }
}

export function fetchDownloadableAgendaRequest(data) {
  return { type: REQUEST, data };
}

export function fetchDownloadableAgendaSuccess(data) {
  return { type: SUCCESS, data };
}

export function fetchDownloadableAgendaFailure(data) {
  return { type: FAILURE, data };
}

export function fetchDownloadableAgendaAction() {
  return function (dispatch, getState, { Api, i18n }) {
    dispatch(fetchDownloadableAgendaRequest());

    const {
      pageConfig: { previewMode, siteId, siteTypePath },
      siteType: { data: { primaryLocale = 'en' } = {} } = {},
    } = getState();
    const queryParams = `?primaryLocale=${primaryLocale}`;

    return Api()
      .service('ContentService')
      .version('v1')
      .setup({
        headers: {
          'Accept-Language': i18n.language,
          'Published-State': getPublishedStateHeader(previewMode),
        },
      })
      .fetchDownloadableAgenda({ siteTypePath, siteId, queryParams })
      .then((response) => {
        if (response.statusCode === 200) {
          return dispatch(fetchDownloadableAgendaSuccess(response));
        } else {
          return dispatch(fetchDownloadableAgendaFailure(response));
        }
      });
  };
}
